export class DriverPouchMiniEntity {
  id?: number
  driverId?: number
  driverFullName?: string | null
  driverTeams?: Array<{
    id?: number
    name?: string | null
  }> | null
  amount?: number
  lastInTransactionAt?: string | null
  lastOutTransactionAt?: string | null
  maxAmountLimit?: number
  pouchDefaultMaxAmountLimit?: number
  isDriverHalted?: boolean
  totalTransactionAmount?: number
  isDriverBlocked?: boolean
}
